import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import {ConnectionUserWithLocation, ConnectionsGroupedByBuilding} from './types';
import {
  ConnectionUser,
  Workday,
  WorkspaceReservation,
  getWorkspaceReservationSpaceNodeId,
  getWorkspaceReservationSpaceNodeName,
} from '../../data';
import {stringCompare} from '@lib/utils';
import {connectionGroupComparator} from './helpers';
import {Dictionary} from '@reduxjs/toolkit';

export const groupConnectionsByWorkdayBuilding = (
  defaultBuildingId: string,
  connectedUsers: Dictionary<ConnectionUser>,
  connectionWorkspaceReservations: WorkspaceReservation[],
  loggedInUserWorkspaceReservation: WorkspaceReservation | undefined,
  connectionWorkdays: Workday[],
) =>
  map(
    groupBy(
      connectionWorkdays.filter((workday) => workday.status === 'OfficeDay'),
      (workday) => workday.nodeId,
    ),
    (workdays, buildingId): ConnectionsGroupedByBuilding => ({
      buildingId,
      buildingName: workdays.find((workday) => workday.nodeId === buildingId)?.nodeName ?? '',
      isDefaultBuilding: defaultBuildingId === buildingId,
      data: map(workdays, (workday): ConnectionUserWithLocation => {
        const workspaceReservation =
          connectionWorkspaceReservations.find((reservation) => reservation.userId === workday.userId) ??
          ({floorId: '', floorNumber: 0, areaId: '', areaName: ''} as WorkspaceReservation);
        return {
          connectionUser: connectedUsers[workday.userId] ?? ({} as ConnectionUser),
          floorId: workspaceReservation.floorId,
          floorNumber: workspaceReservation.floorNumber,
          areaId: workspaceReservation.areaId,
          areaName: workspaceReservation.areaName,
          nodeId: workspaceReservation.id ? getWorkspaceReservationSpaceNodeId(workspaceReservation) : '',
          workspaceReservationSpaceNodeName: workspaceReservation.id
            ? getWorkspaceReservationSpaceNodeName(workspaceReservation)
            : '',
        };
      }).sort((a, b) => stringCompare(a.connectionUser.name, b.connectionUser.name)),
    }),
  ).sort((firstGroup, secondGroup) =>
    connectionGroupComparator(firstGroup, secondGroup, loggedInUserWorkspaceReservation?.buildingId ?? ''),
  );
